export enum ButtonTypes {
    RAISED = 'raised',
    FLAT = 'flat',
    STROKED = 'stroked',
    MENU = 'menu',
}
